(() => {
  "use strict";

  const existingMoney = window.JSCAMoney;
  const money = existingMoney && (typeof existingMoney === "object" || typeof existingMoney === "function") ? existingMoney : {};
  if (typeof money.format !== "function") {
    const formats = {
      amount: [2, ",", "."],
      amount_no_decimals: [0, ",", "."],
      amount_with_comma_separator: [2, ".", ","],
      amount_no_decimals_with_comma_separator: [0, ".", ","],
      amount_with_apostrophe_separator: [2, "'", "."],
      amount_no_decimals_with_apostrophe_separator: [0, "'", "."],
      amount_with_space_separator: [2, " ", ","],
      amount_no_decimals_with_space_separator: [0, " ", "."],
      amount_with_period_and_space_separator: [2, " ", "."]
    };
    money.format = (cents, format) => {
      const value = Number(cents);
      if (!Number.isFinite(value) || typeof format !== "string") return "";
      const placeholder = format.match(/\{\{\s*(amount(?:_[a-z_]+)?)\s*\}\}/);
      const settings = placeholder ? formats[placeholder[1]] : null;
      if (!settings) return "";
      const [precision, thousands, decimal] = settings;
      const [whole, fraction = ""] = (Math.abs(value) / 100).toFixed(precision).split(".");
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      const amount = `${value < 0 ? "-" : ""}${grouped}${precision ? `${decimal}${fraction}` : ""}`;
      return format.replace(placeholder[0], amount);
    };
  }
  window.JSCAMoney = money;

  if (typeof window.__jscaCartCountUpdatedHandler !== "function") {
    window.__jscaCartCountUpdatedHandler = (event) => {
      const rawItemCount = event.detail?.cart?.item_count;
      const itemCount = typeof rawItemCount === "number"
        ? rawItemCount
        : typeof rawItemCount === "string" && /^(?:0|[1-9]\d*)$/.test(rawItemCount)
          ? Number(rawItemCount)
          : NaN;
      if (!Number.isSafeInteger(itemCount) || itemCount < 0) return;
      document.querySelectorAll(".jsca-header__cart-count").forEach((count) => {
        count.textContent = String(itemCount);
        count.closest("a")?.setAttribute("aria-label", `Cart, ${itemCount} ${itemCount === 1 ? "item" : "items"}`);
      });
    };
    document.addEventListener("jsca:cart:updated", window.__jscaCartCountUpdatedHandler);
  }

  const dialog = document.querySelector("[data-quick-view]");
  if (!dialog || typeof dialog.showModal !== "function" || window.__jscaQuickView) return;

  const panel = dialog.querySelector("[data-quick-view-panel]");
  const closeButton = dialog.querySelector("[data-quick-view-close]");
  const loading = dialog.querySelector("[data-quick-view-loading]");
  const errorPanel = dialog.querySelector("[data-quick-view-error]");
  const errorMessage = dialog.querySelector("[data-quick-view-error-message]");
  const errorLink = dialog.querySelector("[data-quick-view-error-link]");
  const retryButton = dialog.querySelector("[data-quick-view-retry]");
  const content = dialog.querySelector("[data-quick-view-content]");
  const label = dialog.querySelector("[data-quick-view-label]");
  const status = dialog.querySelector("[data-quick-view-status]");
  const policyTemplate = dialog.querySelector("[data-quick-view-policy-template]");

  if (!panel || !closeButton || !loading || !errorPanel || !errorMessage || !errorLink || !retryButton || !content || !label || !status) return;

  const cache = new Map();
  const cacheTtl = 60_000;
  const productFetchTimeout = 10_000;
  const addRequestTimeout = 12_000;
  const cartRefreshTimeout = 3_500;
  const ambiguousAddMessage = "We couldn’t confirm whether this item was added. Check your bag before trying again.";
  const soldOutMessage = "This selection just sold out.";
  const inventoryFailure = /\b(?:sold out|out of stock|insufficient inventory|not enough (?:items? )?in stock|inventory (?:is )?(?:unavailable|depleted)|requested quantity (?:is )?(?:not available|unavailable))\b/i;
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const badgeLabels = new Set([
    "NEW",
    "NEW STYLE",
    "NEW COLOR",
    "RELAXED",
    "FITTED",
    "OVERSIZED",
    "UNISEX",
    "RESTOCKED",
    "LIMITED",
    "SALE"
  ]);
  const allowedDescriptionTags = new Set([
    "P", "BR", "UL", "OL", "LI", "STRONG", "B", "EM", "I", "U", "S", "A",
    "H1", "H2", "H3", "H4", "H5", "H6", "BLOCKQUOTE", "DL", "DT", "DD",
    "TABLE", "THEAD", "TBODY", "TFOOT", "TR", "TH", "TD", "CAPTION", "HR", "SPAN"
  ]);
  const state = {
    opener: null,
    trigger: null,
    productUrl: "",
    jsonUrl: "",
    product: null,
    selections: [],
    optionButtons: [],
    selectedVariant: null,
    price: null,
    activeColor: null,
    variantInput: null,
    addButton: null,
    purchaseForm: null,
    announcer: null,
    gallery: null,
    galleryFrame: 0,
    renderCleanup: [],
    fetchController: null,
    addController: null,
    requestSequence: 0,
    addSequence: 0,
    adding: false
  };
  const existingCartCoordinator = window.__jscaCartCoordinator;
  const cartCoordinator = existingCartCoordinator && typeof existingCartCoordinator === "object" ? existingCartCoordinator : {};
  if (!Number.isSafeInteger(cartCoordinator.refreshSequence) || cartCoordinator.refreshSequence < 0) cartCoordinator.refreshSequence = 0;
  if (!Number.isSafeInteger(cartCoordinator.latestRefreshToken) || cartCoordinator.latestRefreshToken < 0) {
    cartCoordinator.latestRefreshToken = cartCoordinator.refreshSequence;
  }
  cartCoordinator.refreshSequence = Math.max(cartCoordinator.refreshSequence, cartCoordinator.latestRefreshToken);
  cartCoordinator.latestRefreshToken = cartCoordinator.refreshSequence;
  if (typeof cartCoordinator.reserveRefresh !== "function") {
    cartCoordinator.reserveRefresh = () => {
      cartCoordinator.refreshSequence += 1;
      cartCoordinator.latestRefreshToken = cartCoordinator.refreshSequence;
      return cartCoordinator.latestRefreshToken;
    };
  }
  if (typeof cartCoordinator.isLatestRefresh !== "function") {
    cartCoordinator.isLatestRefresh = (token) => token === cartCoordinator.latestRefreshToken;
  }
  window.__jscaCartCoordinator = cartCoordinator;
  let backdropPointerId = null;

  const cartAddUrl = internalPath(dialog.dataset.cartAddUrl);
  const cartUrl = internalPath(dialog.dataset.cartUrl);
  const fallbackFormatter = createMoneyFormatter(dialog.dataset.currency);
  const moneyFormat = dialog.dataset.moneyFormat;

  function createElement(tagName, className, text) {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function internalPath(value, includeHash = false) {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin || (url.protocol !== "http:" && url.protocol !== "https:")) return null;
      return `${url.pathname}${url.search}${includeHash ? url.hash : ""}`;
    } catch (_) {
      return null;
    }
  }

  function createMoneyFormatter(currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: /^[A-Z]{3}$/.test(currency || "") ? currency : "USD"
      });
    } catch (_) {
      return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
    }
  }

  function formatMoney(value) {
    const cents = Number(value);
    if (!Number.isFinite(cents)) return "";
    try {
      return money.format(cents, moneyFormat) || fallbackFormatter.format(cents / 100);
    } catch (_) {
      return fallbackFormatter.format(cents / 100);
    }
  }

  function textValue(value) {
    if (typeof value === "string") return value.trim();
    if (typeof value === "number") return String(value);
    if (value && typeof value === "object") return textValue(value.value ?? value.name ?? value.title);
    return "";
  }

  function imageUrl(value) {
    if (typeof value === "string") return safeImageUrl(value);
    if (!value || typeof value !== "object") return "";
    return imageUrl(value.src || value.url || value.preview_image || value.featured_image);
  }

  function safeImageUrl(value) {
    if (!value) return "";
    const source = String(value).trim();
    if (/^data:image\/[^,]+,/i.test(source)) return source;
    try {
      const url = new URL(source, window.location.href);
      return url.protocol === "http:" || url.protocol === "https:" ? url.href : "";
    } catch (_) {
      return "";
    }
  }

  function shopifyImageUrl(value, width) {
    const safeUrl = safeImageUrl(value);
    if (!safeUrl || safeUrl.startsWith("data:")) return safeUrl;
    const url = new URL(safeUrl);
    const hostname = url.hostname.toLowerCase();
    const shopifyHosted = hostname === "cdn.shopify.com"
      || hostname.endsWith(".shopifycdn.com")
      || hostname.endsWith(".myshopify.com")
      || (url.origin === window.location.origin && url.pathname.startsWith("/cdn/shop/"));
    if (!shopifyHosted) return safeUrl;
    url.searchParams.set("width", String(Math.max(1, Math.min(2000, Math.round(width)))));
    return url.href;
  }

  function imageKey(value) {
    const safeUrl = safeImageUrl(value);
    if (!safeUrl) return "";
    if (safeUrl.startsWith("data:")) return safeUrl;
    const url = new URL(safeUrl);
    return `${url.hostname}${url.pathname}`;
  }

  function numericValue(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  async function parseJsonResponse(response) {
    const text = await response.text();
    if (!text.trim()) return { parsed: false, payload: null };
    try {
      return { parsed: true, payload: JSON.parse(text) };
    } catch (_) {
      return { parsed: false, payload: null };
    }
  }

  async function withTimeout(task, controller, timeoutMs, code) {
    let timedOut = false;
    let timeoutId = 0;
    const timeout = new Promise((_, reject) => {
      timeoutId = window.setTimeout(() => {
        timedOut = true;
        controller.abort();
        reject(Object.assign(new Error(code), { code }));
      }, timeoutMs);
    });
    try {
      return await Promise.race([Promise.resolve().then(task), timeout]);
    } catch (error) {
      if (timedOut) throw Object.assign(new Error(code), { code });
      throw error;
    } finally {
      window.clearTimeout(timeoutId);
    }
  }

  function isRecord(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
  }

  function idLike(value) {
    if (Number.isInteger(value) && value > 0) return true;
    return typeof value === "string" && value.length <= 120 && /\d/.test(value) && /^[A-Za-z0-9:/_-]+$/.test(value);
  }

  function validCartAddPayload(payload) {
    if (!isRecord(payload)) return false;
    if (idLike(payload.id)) return true;
    return Array.isArray(payload.items)
      && payload.items.length > 0
      && payload.items.every((item) => isRecord(item) && idLike(item.id ?? item.variant_id));
  }

  function safeShopifyMessage(payload) {
    if (!isRecord(payload)) return "";
    const candidate = [payload.description, payload.message, payload.error, payload.errors]
      .find((value) => typeof value === "string");
    if (!candidate) return "";
    const message = candidate.replace(/\s+/g, " ").trim();
    return message && message.length <= 240 && !/[<>]/.test(message) ? message : "";
  }

  function inventoryUnavailable(statusCode, message) {
    return (statusCode === 409 || statusCode === 422) && inventoryFailure.test(message);
  }

  function shouldInvalidateCache(statusCode) {
    return [404, 409, 422].includes(statusCode);
  }

  function invalidateVariant(jsonUrl, variantId) {
    cache.delete(jsonUrl);
    if (state.jsonUrl !== jsonUrl || !state.product) return;
    const variant = state.product.variants.find((item) => item.id === variantId);
    if (variant) variant.available = false;
    state.selectedVariant = null;
    updateSelection(false);
  }

  function normalizeProduct(payload) {
    if (!payload || typeof payload !== "object") throw new Error("missing-product");
    const title = textValue(payload.title);
    if (!title || !Array.isArray(payload.variants) || !payload.variants.length) throw new Error("missing-product");

    const variants = payload.variants.map((variant) => {
      const rawOptions = Array.isArray(variant.options)
        ? variant.options
        : [variant.option1, variant.option2, variant.option3].filter((value) => value !== undefined && value !== null);
      const normalizedOptions = rawOptions.map(textValue);
      return {
        id: textValue(variant.id),
        title: textValue(variant.title || variant.public_title) || normalizedOptions.filter(Boolean).join(" / "),
        available: variant.available === true,
        price: numericValue(variant.price),
        compareAtPrice: numericValue(variant.compare_at_price),
        options: normalizedOptions,
        imageUrl: imageUrl(variant.featured_image || variant.featured_media)
      };
    }).filter((variant) => variant.id);

    if (!variants.length) throw new Error("missing-product");

    const rawOptions = Array.isArray(payload.options) ? payload.options : [];
    const optionCount = Math.min(3, Math.max(rawOptions.length, ...variants.map((variant) => variant.options.length)));
    let options = Array.from({ length: optionCount }, (_, index) => {
      const rawOption = rawOptions[index];
      const name = textValue(typeof rawOption === "object" ? rawOption.name : rawOption) || `Option ${index + 1}`;
      const declaredValues = rawOption && typeof rawOption === "object" && Array.isArray(rawOption.values)
        ? rawOption.values.map(textValue).filter(Boolean)
        : [];
      const variantValues = variants.map((variant) => variant.options[index]).filter(Boolean);
      return { name, values: [...new Set([...declaredValues, ...variantValues])] };
    });

    const defaultOption = options.length === 1
      && variants.length === 1
      && options[0].name.toLowerCase() === "title"
      && options[0].values.length === 1
      && options[0].values[0].toLowerCase() === "default title";
    if (defaultOption) {
      options = [];
      variants.forEach((variant) => { variant.options = []; });
    }

    const images = [];
    const seenImages = new Set();
    const addImage = (source, alt = "") => {
      const url = imageUrl(source);
      const key = imageKey(url);
      if (!url || !key || seenImages.has(key)) return;
      seenImages.add(key);
      images.push({ url, key, alt: textValue(alt) });
    };

    if (Array.isArray(payload.media)) {
      payload.media.forEach((media) => {
        if (media && media.media_type && media.media_type !== "image") return;
        addImage(media, media?.alt);
      });
    }
    if (Array.isArray(payload.images)) payload.images.forEach((image) => addImage(image, image?.alt));
    addImage(payload.featured_image, payload.featured_image?.alt);
    variants.forEach((variant) => addImage(variant.imageUrl));

    const tags = Array.isArray(payload.tags)
      ? payload.tags
      : typeof payload.tags === "string" ? payload.tags.split(",") : [];

    return {
      title,
      vendor: textValue(payload.vendor),
      type: textValue(payload.type || payload.product_type),
      description: typeof payload.description === "string" ? payload.description : "",
      tags: tags.map(textValue).filter(Boolean),
      options,
      variants,
      images
    };
  }

  function sanitizeDescription(html) {
    const parsed = new DOMParser().parseFromString(`<body>${html || ""}</body>`, "text/html");
    parsed.body.querySelectorAll("script,style,iframe,object,embed").forEach((element) => element.remove());

    Array.from(parsed.body.querySelectorAll("*")).forEach((element) => {
      if (!allowedDescriptionTags.has(element.tagName)) {
        element.replaceWith(...element.childNodes);
        return;
      }

      const href = element.tagName === "A" ? internalPath(element.getAttribute("href"), true) : null;
      Array.from(element.attributes).forEach((attribute) => element.removeAttribute(attribute.name));
      if (href) element.setAttribute("href", href);
    });

    const container = document.createElement("div");
    container.append(...Array.from(parsed.body.childNodes).map((node) => document.importNode(node, true)));
    return container;
  }
  function selectedVariants(selections = state.selections) {
    return state.product.variants.filter((variant) => selections.every((value, index) => value === null || variant.options[index] === value));
  }

  function exactVariant() {
    if (state.selections.some((value) => value === null)) return null;
    return state.product.variants.find((variant) => variant.options.every((value, index) => value === state.selections[index])) || null;
  }

  function optionIsAvailable(optionIndex, value) {
    const nextSelections = state.selections.map((selected, index) => index < optionIndex ? selected : null);
    nextSelections[optionIndex] = value;
    return state.product.variants.some((variant) => variant.available && nextSelections.every((selected, index) => selected === null || variant.options[index] === selected));
  }

  function selectOption(optionIndex, value) {
    state.selections[optionIndex] = value;
    const sizeIndex = state.product.options.findIndex((option) => /^size$/i.test(option.name));

    for (let index = optionIndex + 1; index < state.product.options.length; index += 1) {
      if (index === sizeIndex) {
        state.selections[index] = null;
        continue;
      }

      const currentValue = state.selections[index];
      const currentWorks = state.product.variants.some((variant) => variant.available
        && state.selections.slice(0, index).every((selected, selectedIndex) => selected === null || variant.options[selectedIndex] === selected)
        && variant.options[index] === currentValue);
      if (currentWorks) continue;

      const fallback = state.product.variants.find((variant) => variant.available
        && state.selections.slice(0, index).every((selected, selectedIndex) => selected === null || variant.options[selectedIndex] === selected));
      state.selections[index] = fallback?.options[index] || null;
    }
  }

  function renderPrice(variant) {
    if (!state.price) return;
    state.price.replaceChildren();
    const compatible = variant ? [variant] : selectedVariants();
    const available = compatible.filter((item) => item.available);
    const pool = variant ? compatible : available.length ? available : compatible;
    const prices = pool.map((item) => item.price).filter(Number.isFinite).sort((a, b) => a - b);
    if (!prices.length) {
      state.price.textContent = "Price available on product page";
      return;
    }

    const minimum = prices[0];
    const maximum = prices[prices.length - 1];
    state.price.append(document.createTextNode(minimum === maximum ? formatMoney(minimum) : `${formatMoney(minimum)} – ${formatMoney(maximum)}`));

    const allOnSale = pool.length > 0 && pool.every((item) => Number.isFinite(item.price)
      && Number.isFinite(item.compareAtPrice)
      && item.compareAtPrice > item.price);
    if (!allOnSale) return;

    const comparisons = pool.map((item) => item.compareAtPrice).sort((a, b) => a - b);
    const comparisonMinimum = comparisons[0];
    const comparisonMaximum = comparisons[comparisons.length - 1];
    const comparison = comparisonMinimum === comparisonMaximum
      ? formatMoney(comparisonMinimum)
      : `${formatMoney(comparisonMinimum)} – ${formatMoney(comparisonMaximum)}`;
    state.price.append(createElement("s", "", comparison));
  }

  function updateGalleryControls() {
    const gallery = state.gallery;
    if (!gallery || !gallery.slides.length) return;
    const locked = state.adding;
    const previousDisabled = locked || gallery.index === 0;
    const nextDisabled = locked || gallery.index === gallery.slides.length - 1;
    gallery.track.tabIndex = locked || gallery.slides.length < 2 ? -1 : 0;
    gallery.track.setAttribute("aria-disabled", String(locked));
    const focusedControl = document.activeElement;
    if (focusedControl === gallery.previous && previousDisabled) {
      gallery.next.disabled = nextDisabled;
      gallery.next.setAttribute("aria-disabled", String(nextDisabled));
      (nextDisabled ? gallery.track : gallery.next).focus({ preventScroll: true });
    } else if (focusedControl === gallery.next && nextDisabled) {
      gallery.previous.disabled = previousDisabled;
      gallery.previous.setAttribute("aria-disabled", String(previousDisabled));
      (previousDisabled ? gallery.track : gallery.previous).focus({ preventScroll: true });
    }
    gallery.previous.disabled = previousDisabled;
    gallery.previous.setAttribute("aria-disabled", String(previousDisabled));
    gallery.next.disabled = nextDisabled;
    gallery.next.setAttribute("aria-disabled", String(nextDisabled));
  }

  function afterNextFrame(callback) {
    let completed = false;
    let timeoutId = 0;
    const run = () => {
      if (completed) return;
      completed = true;
      window.clearTimeout(timeoutId);
      callback();
    };
    timeoutId = window.setTimeout(run, 80);
    window.requestAnimationFrame(run);
  }

  function setGalleryScrollInstantly(track, left) {
    const previousBehavior = track.style.scrollBehavior;
    track.style.scrollBehavior = "auto";
    track.scrollLeft = left;
    void track.offsetWidth;
    afterNextFrame(() => {
      if (!track.isConnected) return;
      if (previousBehavior) track.style.scrollBehavior = previousBehavior;
      else track.style.removeProperty("scroll-behavior");
    });
  }

  function updateGallery(index, move = true, force = false, animate = true) {
    const gallery = state.gallery;
    if (!gallery || !gallery.slides.length || state.adding && !force) return;
    const bounded = Math.max(0, Math.min(index, gallery.slides.length - 1));
    gallery.index = bounded;
    updateGalleryControls();
    const positionText = `Image ${bounded + 1} of ${gallery.slides.length}`;
    if (gallery.position.textContent !== positionText) gallery.position.textContent = positionText;
    if (!move) return;
    const left = gallery.slides[bounded].offsetLeft;
    if (!animate || reducedMotion.matches) setGalleryScrollInstantly(gallery.track, left);
    else gallery.track.scrollTo({ left, behavior: "smooth" });
  }

  function nearestGalleryIndex() {
    const gallery = state.gallery;
    if (!gallery || !gallery.slides.length) return 0;
    let nearest = 0;
    let distance = Infinity;
    gallery.slides.forEach((slide, index) => {
      const nextDistance = Math.abs(slide.offsetLeft - gallery.track.scrollLeft);
      if (nextDistance < distance) {
        nearest = index;
        distance = nextDistance;
      }
    });
    return nearest;
  }

  function scheduleGalleryUpdate() {
    if (state.adding || state.galleryFrame) return;
    state.galleryFrame = window.requestAnimationFrame(() => {
      state.galleryFrame = 0;
      updateGallery(nearestGalleryIndex(), false);
    });
  }

  function focusVariantImage(variant, animate = true, force = false) {
    if (!variant?.imageUrl || !state.gallery) return;
    const key = imageKey(variant.imageUrl);
    const index = state.gallery.keys.indexOf(key);
    if (index >= 0 && index !== state.gallery.index) updateGallery(index, true, force, animate);
  }

  function updateSelection(updateMedia = false) {
    const variant = exactVariant();
    state.selectedVariant = variant?.available ? variant : null;

    state.optionButtons.forEach(({ button, index, value, optionName }) => {
      const available = optionIsAvailable(index, value);
      const selected = state.selections[index] === value;
      button.disabled = state.adding || !available;
      button.setAttribute("aria-disabled", String(button.disabled));
      button.setAttribute("aria-pressed", String(selected));
      button.setAttribute("aria-label", `${optionName}: ${value}${available ? "" : ", unavailable"}`);
    });

    const colorIndex = state.product.options.findIndex((option) => /^(color|colour)$/i.test(option.name));
    if (state.activeColor && colorIndex >= 0) state.activeColor.textContent = state.selections[colorIndex] || "Choose a color";
    renderPrice(variant);

    const availableVariants = state.product.variants.filter((item) => item.available);
    const sizeIndex = state.product.options.findIndex((option) => /^size$/i.test(option.name));
    const missingSize = sizeIndex >= 0 && state.selections[sizeIndex] === null;
    const missingOption = state.selections.some((value) => value === null);

    if (!availableVariants.length) {
      state.addButton.textContent = "Sold out";
      state.addButton.disabled = true;
    } else if (missingSize) {
      state.addButton.textContent = "Select size";
      state.addButton.disabled = true;
    } else if (missingOption || !variant) {
      state.addButton.textContent = "Select options";
      state.addButton.disabled = true;
    } else if (!variant.available) {
      state.addButton.textContent = "Sold out";
      state.addButton.disabled = true;
    } else {
      const variantTitle = variant.title && variant.title.toLowerCase() !== "default title" ? ` ${variant.title}` : "";
      state.addButton.textContent = `Add${variantTitle} to bag`;
      state.addButton.disabled = false;
    }

    state.addButton.setAttribute("aria-disabled", String(state.addButton.disabled || state.adding));
    state.addButton.classList.toggle("is-loading", state.adding);
    state.variantInput.value = state.selectedVariant?.id || "";
    if (updateMedia) focusVariantImage(variant || selectedVariants().find((item) => item.available));
    updateGalleryControls();
  }

  function setAddingState(adding) {
    state.adding = adding;
    panel.classList.toggle("is-adding", adding);
    state.purchaseForm?.setAttribute("aria-busy", String(adding));
    updateSelection(false);
  }

  function focusAnnouncement() {
    const announcement = state.announcer;
    if (!announcement?.isConnected) return;
    announcement.tabIndex = -1;
    announcement.addEventListener("blur", () => announcement.removeAttribute("tabindex"), { once: true });
    announcement.focus();
  }

  function buildGallery(product) {
    const media = createElement("section", "jsca-quick-view__media");
    media.setAttribute("aria-label", "Product media");
    const shell = createElement("div", "jsca-quick-view__gallery-shell");
    const track = createElement("ul", "jsca-quick-view__gallery");
    track.setAttribute("role", "list");
    track.setAttribute("aria-label", `${product.title} product images`);

    const images = product.images.length ? product.images : [{ url: "", key: "", alt: "" }];
    const slides = images.map((image, index) => {
      const slide = createElement("li", "jsca-quick-view__media-card");
      if (image.url) {
        const picture = document.createElement("img");
        const widths = [320, 480, 640, 800, 1000];
        const sources = widths.map((width) => shopifyImageUrl(image.url, width));
        picture.src = shopifyImageUrl(image.url, 800);
        picture.sizes = "(max-width: 500px) 80vw, (max-width: 1024px) 400px, 450px";
        if (new Set(sources).size === widths.length) {
          picture.srcset = sources.map((source, sourceIndex) => `${source} ${widths[sourceIndex]}w`).join(", ");
        }
        picture.alt = image.alt || `${product.title} — view ${index + 1} of ${images.length}`;
        picture.loading = index === 0 ? "eager" : "lazy";
        picture.decoding = "async";
        picture.dataset.quickViewGalleryImage = "";
        slide.append(picture);
      } else {
        const fallback = createElement("span", "jsca-quick-view__image-fallback", "Product image unavailable");
        fallback.setAttribute("role", "img");
        fallback.setAttribute("aria-label", `Product image unavailable for ${product.title}`);
        slide.append(fallback);
      }
      track.append(slide);
      return slide;
    });

    const previous = createElement("button", "jsca-quick-view__gallery-button jsca-quick-view__gallery-button--previous", "←");
    previous.type = "button";
    previous.setAttribute("aria-label", "Previous product image");
    previous.dataset.quickViewGalleryPrevious = "";
    const next = createElement("button", "jsca-quick-view__gallery-button jsca-quick-view__gallery-button--next", "→");
    next.type = "button";
    next.setAttribute("aria-label", "Next product image");
    next.dataset.quickViewGalleryNext = "";
    const position = createElement("p", "jsca-quick-view__gallery-position");
    position.setAttribute("aria-atomic", "true");

    shell.append(track, previous, next, position);
    media.append(shell);
    state.gallery = { track, slides, previous, next, position, keys: images.map((image) => image.key), index: 0 };
    track.addEventListener("scroll", scheduleGalleryUpdate, { passive: true });
    state.renderCleanup.push(() => track.removeEventListener("scroll", scheduleGalleryUpdate));
    updateGallery(0, false, true, false);
    return media;
  }

  function buildHeader(product) {
    const header = createElement("header", "jsca-quick-view__product-header");
    const normalizedTags = product.tags.map((tag) => tag.replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim().toUpperCase());
    const badges = [...new Set(normalizedTags.filter((tag) => badgeLabels.has(tag)))].slice(0, 4);
    if (badges.length) {
      const badgeList = createElement("div", "jsca-quick-view__badges");
      badges.forEach((badge) => badgeList.append(createElement("span", "jsca-quick-view__badge", badge)));
      header.append(badgeList);
    }

    header.append(createElement("h2", "jsca-quick-view__title", product.title));
    const subtitleParts = [...new Set([product.type, product.vendor].filter(Boolean))];
    if (subtitleParts.length) header.append(createElement("p", "jsca-quick-view__subtitle", subtitleParts.join(" / ")));

    const colorIndex = product.options.findIndex((option) => /^(color|colour)$/i.test(option.name));
    if (colorIndex >= 0) {
      const color = createElement("p", "jsca-quick-view__active-color", "Color: ");
      state.activeColor = createElement("strong", "", state.selections[colorIndex] || "Choose a color");
      color.append(state.activeColor);
      header.append(color);
    }

    state.price = createElement("p", "jsca-quick-view__price");
    header.append(state.price);
    return header;
  }

  function buildOptions(product) {
    const options = createElement("div", "jsca-quick-view__options");
    if (!product.options.length) options.hidden = true;

    product.options.forEach((option, optionIndex) => {
      const isSize = /^size$/i.test(option.name);
      const isColor = /^(color|colour)$/i.test(option.name);
      const fieldset = createElement("fieldset", `jsca-quick-view__option${isSize ? " jsca-quick-view__option--size" : ""}${isColor ? " jsca-quick-view__option--color" : ""}`);
      const legend = createElement("legend", "", `${option.name}${isColor ? ` (${option.values.length})` : ""}`);
      const values = createElement("div", "jsca-quick-view__option-values");

      option.values.forEach((value) => {
        const button = createElement("button", "jsca-quick-view__option-button");
        button.type = "button";
        button.dataset.quickViewOption = "";
        button.dataset.optionIndex = String(optionIndex);
        button.dataset.optionValue = value;

        if (isColor) {
          const swatch = createElement("span", "jsca-quick-view__swatch");
          swatch.setAttribute("aria-hidden", "true");
          const variant = product.variants.find((item) => item.options[optionIndex] === value && item.imageUrl);
          if (variant?.imageUrl) {
            const image = document.createElement("img");
            image.src = shopifyImageUrl(variant.imageUrl, 120);
            image.alt = "";
            image.loading = "lazy";
            image.dataset.quickViewSwatchImage = "";
            swatch.append(image);
          } else {
            swatch.textContent = value.slice(0, 1).toUpperCase();
          }
          button.append(swatch, createElement("span", "jsca-quick-view__swatch-label", value));
        } else {
          button.textContent = value;
        }

        state.optionButtons.push({ button, index: optionIndex, value, optionName: option.name });
        values.append(button);
      });

      fieldset.append(legend, values);
      options.append(fieldset);
    });
    return options;
  }

  function buildHighlights(body) {
    const highlights = createElement("section", "jsca-quick-view__highlights");
    highlights.append(createElement("h3", "", "HIGHLIGHTS"));
    highlights.hidden = !body || !body.childNodes.length;
    if (body) highlights.append(...Array.from(body.childNodes));
    return highlights;
  }

  function buildAccordion(labelText, body) {
    const details = createElement("details", "jsca-quick-view__accordion");
    const summary = document.createElement("summary");
    summary.append(createElement("span", "", labelText), createElement("span", "jsca-quick-view__accordion-icon", "+"));
    summary.lastElementChild.setAttribute("aria-hidden", "true");
    const description = createElement("div", "jsca-quick-view__description");
    details.hidden = !body || !body.childNodes.length;
    if (body) description.append(...Array.from(body.childNodes));
    details.append(summary, description);
    return details;
  }

  // Keep this stack aligned with snippets/jsca-product-buy-box.liquid:
  // badges, title, subtitle, color, price, swatches, size, ATC, expanders.
  function buildProductDetails(product) {
    const details = createElement("div", "jsca-quick-view__details");
    let sections = { description: sanitizeDescription(product.description) };
    try {
      if (window.JSCAProductDescription) sections = window.JSCAProductDescription.split(product.description);
    } catch (_) {}
    const header = buildHeader(product);
    const options = buildOptions(product);
    const highlights = buildHighlights(sections.highlights);
    const accordions = createElement("div", "jsca-quick-view__accordions");
    accordions.append(
      buildAccordion("DESCRIPTION", sections.description),
      buildAccordion("FIT SUGGESTION", sections.fit),
      buildAccordion("MATERIALS AND WASHING DIRECTIONS", sections.materials)
    );

    const fullProduct = createElement("a", "jsca-quick-view__full-product", "View full product");
    fullProduct.href = state.productUrl;

    const purchase = createElement("form", "jsca-quick-view__purchase");
    purchase.method = "post";
    purchase.action = cartAddUrl || state.productUrl;
    purchase.dataset.quickViewAddForm = "";
    purchase.setAttribute("aria-busy", "false");
    state.purchaseForm = purchase;
    state.variantInput = document.createElement("input");
    state.variantInput.type = "hidden";
    state.variantInput.name = "id";
    const quantity = document.createElement("input");
    quantity.type = "hidden";
    quantity.name = "quantity";
    quantity.value = "1";
    state.addButton = createElement("button", "jsca-quick-view__add", "Select options");
    state.addButton.type = "submit";
    state.announcer = createElement("p", "jsca-quick-view__announcement");
    state.announcer.setAttribute("role", "status");
    state.announcer.setAttribute("aria-live", "polite");
    state.announcer.setAttribute("aria-atomic", "true");
    purchase.append(state.variantInput, quantity, state.addButton, state.announcer);
    details.append(header, options, purchase, highlights, accordions, fullProduct);
    if (policyTemplate) details.append(policyTemplate.content.cloneNode(true));
    return details;
  }

  function clearRenderedProduct() {
    state.renderCleanup.splice(0).reverse().forEach((dispose) => dispose());
    window.cancelAnimationFrame(state.galleryFrame);
    state.galleryFrame = 0;
    state.product = null;
    state.selections = [];
    state.optionButtons = [];
    state.selectedVariant = null;
    state.price = null;
    state.activeColor = null;
    state.variantInput = null;
    state.addButton = null;
    state.purchaseForm = null;
    state.announcer = null;
    state.gallery = null;
    content.replaceChildren();
  }

  function renderProduct(product) {
    clearRenderedProduct();
    state.product = product;
    const firstAvailable = product.variants.find((variant) => variant.available) || product.variants[0];
    const sizeIndex = product.options.findIndex((option) => /^size$/i.test(option.name));
    state.selections = product.options.map((_, index) => index === sizeIndex ? null : firstAvailable.options[index] || null);

    const layout = createElement("div", "jsca-quick-view__layout");
    layout.append(buildGallery(product), buildProductDetails(product));
    content.append(layout);
    content.style.visibility = "hidden";
    content.hidden = false;
    updateSelection(false);
    focusVariantImage(firstAvailable, false, true);

    loading.hidden = true;
    errorPanel.hidden = true;
    content.style.removeProperty("visibility");
    panel.removeAttribute("aria-busy");
    const galleryPosition = state.gallery?.position;
    afterNextFrame(() => {
      if (galleryPosition?.isConnected && state.gallery?.position === galleryPosition) galleryPosition.setAttribute("aria-live", "polite");
    });
    label.textContent = `${product.title} quick view`;
    status.textContent = product.images.length
      ? `${product.title} product details loaded.`
      : `${product.title} product details loaded. Product image unavailable.`;
  }

  function showLoading() {
    clearRenderedProduct();
    loading.hidden = false;
    errorPanel.hidden = true;
    content.hidden = true;
    panel.setAttribute("aria-busy", "true");
    label.textContent = "Quick view";
    status.textContent = "Loading product details.";
  }

  function showError(code) {
    const messages = {
      "invalid-json": "The product response could not be read. Try again or view the full product page.",
      "missing-product": "This product is unavailable right now. Try again or view the full product page.",
      timeout: "Product details took too long to load. Try again or view the full product page.",
      network: "We could not load this product. Check your connection and try again."
    };
    clearRenderedProduct();
    loading.hidden = true;
    content.hidden = true;
    errorPanel.hidden = false;
    panel.removeAttribute("aria-busy");
    errorMessage.textContent = messages[code] || messages.network;
    errorLink.href = state.productUrl;
    label.textContent = "Product details unavailable";
    status.textContent = errorMessage.textContent;
  }

  async function loadProduct(sequence) {
    const jsonUrl = state.jsonUrl;
    const cached = cache.get(jsonUrl);
    if (cached && Date.now() - cached.cachedAt < cacheTtl) {
      if (sequence === state.requestSequence && dialog.open) renderProduct(cached.product);
      return;
    }
    cache.delete(jsonUrl);

    const controller = new AbortController();
    state.fetchController = controller;
    try {
      const product = await withTimeout(async () => {
        let response;
        try {
          response = await fetch(jsonUrl, {
            headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
            signal: controller.signal
          });
        } catch (error) {
          if (error.name === "AbortError") throw error;
          throw new Error("network");
        }
        if (!response.ok) throw new Error("network");

        let payload;
        try {
          payload = await response.json();
        } catch (error) {
          if (error.name === "AbortError") throw error;
          throw new Error("invalid-json");
        }
        return normalizeProduct(payload);
      }, controller, productFetchTimeout, "product-timeout");
      cache.set(jsonUrl, { product, cachedAt: Date.now() });
      if (sequence === state.requestSequence && dialog.open) renderProduct(product);
    } catch (error) {
      const timedOut = error.code === "product-timeout";
      if (controller.signal.aborted && !timedOut || sequence !== state.requestSequence || !dialog.open) return;
      showError(timedOut ? "timeout" : error.message === "missing-product" || error.message === "invalid-json" ? error.message : "network");
    } finally {
      if (state.fetchController === controller) state.fetchController = null;
    }
  }

  function openProduct(trigger) {
    const productUrl = internalPath(trigger.getAttribute("href"), true);
    const jsonUrl = internalPath(trigger.dataset.productJsonUrl);
    if (!productUrl || !jsonUrl) return false;

    if (!dialog.open) {
      try {
        dialog.showModal();
      } catch (_) {
        return false;
      }
    }

    state.fetchController?.abort();
    state.addController?.abort();
    state.adding = false;
    panel.classList.remove("is-adding");
    state.opener = trigger;
    state.trigger = trigger;
    state.productUrl = productUrl;
    state.jsonUrl = jsonUrl;
    errorLink.href = productUrl;
    document.body.classList.add("jsca-quick-view-lock");
    showLoading();
    const sequence = ++state.requestSequence;
    loadProduct(sequence);
    window.requestAnimationFrame(() => closeButton.focus({ preventScroll: true }));
    return true;
  }

  function stopRequests() {
    state.requestSequence += 1;
    state.addSequence += 1;
    state.fetchController?.abort();
    state.addController?.abort();
    state.fetchController = null;
    state.addController = null;
    state.adding = false;
    panel.classList.remove("is-adding");
    state.purchaseForm?.setAttribute("aria-busy", "false");
  }

  function closeQuickView() {
    stopRequests();
    if (dialog.open) dialog.close();
  }

  async function addSelectedVariant(form) {
    if (state.adding || !state.selectedVariant || !cartAddUrl || !cartUrl) return;
    const submittedVariant = state.selectedVariant;
    const submittedVariantId = submittedVariant.id;
    const submittedVariantTitle = submittedVariant.title || "Selected variant";
    const submittedProductTitle = state.product.title;
    const submittedLabel = `${submittedProductTitle}, ${submittedVariantTitle}`;
    const submittedJsonUrl = state.jsonUrl;
    const sequence = ++state.addSequence;
    const productSequence = state.requestSequence;
    const button = state.addButton;
    const controller = new AbortController();
    let focusInventoryMessage = false;
    state.addController?.abort();
    state.addController = controller;
    setAddingState(true);
    button.textContent = "Adding…";
    state.announcer.classList.remove("is-error");
    state.announcer.textContent = `Adding ${submittedLabel} to bag.`;

    try {
      const formData = new FormData(form);
      formData.set("id", submittedVariantId);
      let response;
      let addResult;
      try {
        ({ response, addResult } = await withTimeout(async () => {
          const addResponse = await fetch(cartAddUrl, {
            method: "POST",
            headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
            body: formData,
            signal: controller.signal
          });
          return { response: addResponse, addResult: await parseJsonResponse(addResponse) };
        }, controller, addRequestTimeout, "add-timeout"));
      } catch (error) {
        if (controller.signal.aborted && error.code !== "add-timeout") return;
        throw Object.assign(new Error("add-ambiguous"), {
          ambiguous: true,
          invalidateCache: true,
          userMessage: ambiguousAddMessage
        });
      }

      const shopifyMessage = safeShopifyMessage(addResult.payload);
      if (!response.ok) {
        const failure = new Error("add-failed");
        failure.markVariantUnavailable = inventoryUnavailable(response.status, shopifyMessage);
        failure.userMessage = failure.markVariantUnavailable
          ? soldOutMessage
          : shopifyMessage || "Unable to add this selection. Check your options and try again.";
        failure.invalidateCache = shouldInvalidateCache(response.status);
        throw failure;
      }
      if (!addResult.parsed || !validCartAddPayload(addResult.payload)) {
        throw Object.assign(new Error("add-ambiguous"), {
          ambiguous: true,
          invalidateCache: true,
          userMessage: ambiguousAddMessage
        });
      }
      cache.delete(submittedJsonUrl);

      let cart = null;
      const cartToken = cartCoordinator.reserveRefresh();
      const cartController = new AbortController();
      const abortCartRefresh = () => cartController.abort();
      controller.signal.addEventListener("abort", abortCartRefresh, { once: true });
      try {
        cart = await withTimeout(async () => {
          const cartResponse = await fetch(cartUrl, { headers: { Accept: "application/json" }, signal: cartController.signal });
          if (!cartResponse.ok) return null;
          const cartResult = await parseJsonResponse(cartResponse);
          const itemCount = isRecord(cartResult.payload) ? Number(cartResult.payload.item_count) : NaN;
          return cartResult.parsed && Number.isFinite(itemCount) ? cartResult.payload : null;
        }, cartController, cartRefreshTimeout, "cart-timeout");
      } catch (error) {
        if (controller.signal.aborted) return;
      } finally {
        controller.signal.removeEventListener("abort", abortCartRefresh);
      }

      if (sequence !== state.addSequence || productSequence !== state.requestSequence || !dialog.open) return;
      document.dispatchEvent(new CustomEvent("jsca:cart:updated", {
        detail: { cart: cartCoordinator.isLatestRefresh(cartToken) ? cart : null, item: addResult.payload }
      }));
      state.announcer.textContent = `${submittedLabel} added to bag.`;
    } catch (error) {
      if (sequence !== state.addSequence || productSequence !== state.requestSequence) return;
      if (error.invalidateCache) cache.delete(submittedJsonUrl);
      if (error.markVariantUnavailable) {
        invalidateVariant(submittedJsonUrl, submittedVariantId);
        focusInventoryMessage = true;
      }
      state.announcer.classList.add("is-error");
      state.announcer.textContent = error.userMessage
        ? `${submittedLabel}: ${error.userMessage}`
        : `Unable to add ${submittedLabel}. Check your selection and try again.`;
    } finally {
      if (sequence !== state.addSequence || productSequence !== state.requestSequence) return;
      state.addController = null;
      setAddingState(false);
      if (focusInventoryMessage && state.addButton.disabled) focusAnnouncement();
      else if (button.isConnected && dialog.open) button.focus({ preventScroll: true });
    }
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest?.("[data-quick-view-trigger]");
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (openProduct(trigger)) event.preventDefault();
  });

  dialog.addEventListener("pointerdown", (event) => {
    backdropPointerId = event.isPrimary && event.button === 0 && event.target === dialog ? event.pointerId : null;
  });

  dialog.addEventListener("pointerup", (event) => {
    const shouldClose = backdropPointerId === event.pointerId && event.target === dialog;
    backdropPointerId = null;
    if (shouldClose) closeQuickView();
  });

  dialog.addEventListener("pointercancel", (event) => {
    if (backdropPointerId === event.pointerId) backdropPointerId = null;
  });

  dialog.addEventListener("click", (event) => {
    if (event.target.closest?.("[data-quick-view-close]")) {
      closeQuickView();
      return;
    }
    if (event.target.closest?.("[data-quick-view-retry]")) {
      showLoading();
      const sequence = ++state.requestSequence;
      loadProduct(sequence);
      return;
    }
    if (state.adding) return;

    const option = event.target.closest?.("[data-quick-view-option]");
    if (option && !option.disabled) {
      const optionIndex = Number.parseInt(option.dataset.optionIndex, 10);
      if (Number.isInteger(optionIndex) && state.product?.options[optionIndex]) {
        selectOption(optionIndex, option.dataset.optionValue);
        state.announcer.textContent = "";
        state.announcer.classList.remove("is-error");
        updateSelection(true);
      }
      return;
    }

    if (event.target.closest?.("[data-quick-view-gallery-previous]")) updateGallery((state.gallery?.index || 0) - 1);
    else if (event.target.closest?.("[data-quick-view-gallery-next]")) updateGallery((state.gallery?.index || 0) + 1);
  });

  dialog.addEventListener("submit", (event) => {
    const form = event.target.closest?.("[data-quick-view-add-form]");
    if (!form) return;
    event.preventDefault();
    addSelectedVariant(form);
  });

  dialog.addEventListener("keydown", (event) => {
    const gallery = event.target.closest?.(".jsca-quick-view__gallery");
    if (!gallery || event.target !== gallery || !state.gallery || state.adding) return;
    if (event.key === "ArrowLeft") updateGallery(state.gallery.index - 1);
    else if (event.key === "ArrowRight") updateGallery(state.gallery.index + 1);
    else if (event.key === "Home") updateGallery(0);
    else if (event.key === "End") updateGallery(state.gallery.slides.length - 1);
    else return;
    event.preventDefault();
  });

  dialog.addEventListener("error", (event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement)) return;
    if (image.matches("[data-quick-view-gallery-image]")) {
      const fallback = createElement("span", "jsca-quick-view__image-fallback", "Product image unavailable");
      fallback.setAttribute("role", "img");
      fallback.setAttribute("aria-label", `Product image unavailable for ${state.product?.title || "this product"}`);
      image.replaceWith(fallback);
      status.textContent = "Product image unavailable. Other product details remain available.";
    } else if (image.matches("[data-quick-view-swatch-image]")) {
      const swatch = image.parentElement;
      const value = image.closest("button")?.dataset.optionValue || "";
      image.remove();
      if (swatch) swatch.textContent = value.slice(0, 1).toUpperCase();
    }
  }, true);

  dialog.addEventListener("cancel", (event) => {
    event.preventDefault();
    closeQuickView();
  });

  dialog.addEventListener("close", () => {
    stopRequests();
    document.body.classList.remove("jsca-quick-view-lock");
    const opener = state.opener;
    state.opener = null;
    if (opener?.isConnected) window.requestAnimationFrame(() => opener.focus({ preventScroll: true }));
  });

  document.addEventListener("shopify:section:unload", (event) => {
    if (state.opener && event.target?.contains?.(state.opener)) closeQuickView();
  });

  window.addEventListener("pagehide", stopRequests);
  window.__jscaQuickView = { close: closeQuickView };
})();
